import React, { useEffect, useState } from "react";
import {
  materialRenderers,
  materialCells,
} from "@jsonforms/material-renderers";
import { JsonForms } from "@jsonforms/react";
import { ToastContainer, toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css"; // Стили для редактора
import Navbar from "../components/Navbar";

const schema = {
  type: "object",
  properties: {
    form: {
      title: "",
      type: "object",
      properties: {
        form_name: { type: "string", title: "Название формы" },
        short_name: { type: "string", title: "Короткое название формы" },
        is_visible: { type: "boolean", title: "Видимость" },
        canceled: { type: "boolean", title: "Отменено" },
        restricted: {
          type: "boolean",
          title: "Ограничить доступ (сдают только избранные адвокаты)",
        },
        summary_form_id: {
          type: "number",
          title: "Id формы которую суммируем",
        },
        form_type: {
          type: "string",
          enum: ["summary_report", "main_report"],
          title: "Тип формы",
        },
        created_at: { type: "string", format: "date-time", title: "Создано" },
        updated_at: { type: "string", format: "date-time", title: "Обновлено" },
      },
      required: ["form_name", "form_type"],
    },
    table: {
      type: "array",
      title: "Таблицы",
      items: {
        type: "object",
        properties: {
          title: { type: "string", title: "Название таблицы" },
          type: {
            type: "string",
            title: "Тип таблицы",
            default: "TemplateThree",
          },
          rows: {
            type: "array",
            title: "Строки",
            items: {
              type: "object",
              properties: {
                rowNumber: { type: "string", title: "Номер строки" },
                description: { type: "string", title: "Описание строки" },
                values: {
                  type: "array",
                  title: "Значения",
                  items: { type: "string" },
                },
              },
            },
          },
          rules: {
            type: "array",
            title: "Правила",
            items: {
              type: "object",
              properties: {
                type: { type: "string", title: "Тип правила" },
                target: { type: "string", title: "Цель" },
                sources: {
                  type: "array",
                  title: "Источники",
                  items: { type: "string" },
                },
              },
            },
          },
          headers: {
            type: "array",
            title: "Заголовки",
            items: {
              type: "array",
              items: {
                type: "object",
                properties: {
                  text: { type: "string", title: "Текст" },
                  colSpan: { type: "number", title: "Кол-во столбцов" },
                  rowSpan: { type: "number", title: "Кол-во строк" },
                },
              },
            },
          },
        },
      },
    },
  },
};

const uischema = {
  type: "VerticalLayout",
  elements: [
    { type: "Control", scope: "#/properties/form" },
    { type: "Control", scope: "#/properties/table" },
  ],
};

const FormEdit = (props) => {
  const [data, setData] = useState(props);

  const handleSave = async () => {
    try {
      const response = await fetch(`/forms/${data.form.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        toast.success("Данные успешно сохранены!");
      } else {
        const error = await response.json();
        toast.error(`Ошибка: ${error.message}`);
      }
    } catch (error) {
      toast.error(`Ошибка: ${error.message}`);
    }
  };

  const handleRichTextChange = (key, value) => {
    setData((prevData) => ({
      ...prevData,
      form: {
        ...prevData.form,
        [key]: value,
      },
    }));
  };

  return (
    <>
      <ToastContainer />
      <div className="min-h-full bg-gray-50">
        <div className="pb-32">
          <Navbar props={props} />

          {/* Заголовок */}
          <header className="py-12">
            <div className="mx-auto container max-w-screen-2xl px-4">
              <h1 className="text-3xl font-semibold tracking-tight text-black">
                Редактирование формы
              </h1>
            </div>
          </header>
        </div>

        {/* Основной контент */}
        <main className="-mt-32">
          <div className="mx-auto container max-w-screen-2xl pb-12">
            <div className="overflow-hidden px-5 py-5 rounded-lg bg-white shadow-lg">
              {/* Rich Text Editor */}
              <div className="shadow  ">
                <div className="pb-4"> 
                <div className="mb-6 px-4">
                  <label className="block text-lg font-medium text-gray-700">
                    Заголовок
                  </label>
                  <ReactQuill
                    value={data.form.header || ""}
                    onChange={(value) => handleRichTextChange("header", value)}
                    className="mt-2"
                  />
                </div>

                <div className="mb-6 px-4 ">
                  <label className="block text-lg font-medium text-gray-700">
                    Информация
                  </label>
                  <ReactQuill
                    value={data.form.information || ""}
                    onChange={(value) =>
                      handleRichTextChange("information", value)
                    }
                    className="mt-2"
                  />
                </div>
                </div>
              </div>
              {/* JSON Forms */}
              <JsonForms
                schema={schema}
                uischema={uischema}
                data={data}
                renderers={materialRenderers}
                cells={materialCells}
                onChange={({ data }) => setData(data)}
              />

              <button
                onClick={handleSave}
                className="mt-5 px-4 py-2 bg-blue-600 text-white rounded-md"
              >
                Сохранить
              </button>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default FormEdit;
